export * from './filter';
export * from './oneToOneFilter';
export * from './caseFilter';
export * from './productSamplingStore';
export * from './meetingFilter';
export * from './prospectiveSiteFilter';

export const initialFilterObject = {
	userType: '',
	filter_date: { flagged: false, startDate: null, endDate: null },
	source: '',
	category: '',
	pointsBanked: null as unknown as number,
	physicalVerificationStatus: '',
	adoptionStatus: '',
	mdiCode: '',
};
